<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.24579 1.25274L18.7474 18.7544M18.7474 1.24562L1.24579 18.7473"
			stroke="#D9D9D9"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script setup></script>

<style lang="scss"></style>
